module.exports = __webpack_public_path__ + "media/PunkAngels_reveal_16_9.c449f52c.mp4";